import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  VALIDATE_TOKEN,
  VALIDATE_TOKEN_ERROR,
  VALIDATE_TOKEN_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  login: null,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        error: "",
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        // login: action.payload,
      }
      break

    case LOGOUT_USER:
      state = { ...state, error: "" }
      break

    case LOGOUT_USER_SUCCESS:
      state = { ...state, login: null }
      break

    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break

    case VALIDATE_TOKEN:
      state = { ...state }
      break

    case VALIDATE_TOKEN_ERROR:
      state = { ...state, loading: false, error: action.payload }
      break

    case VALIDATE_TOKEN_SUCCESS:
      state = { ...state, login: action.payload, loading: false }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default login
